import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// must import i18next before other components loading. this is because prevent i18next.t() returning undefined
import './initilize/i18n';
import './index.scss';
import 'rc-slider/assets/index.css';

import { App } from './components/app';
import { Auth } from './components/auth';
import { GoogleAnalytics } from './components/common/GoogleAnalytics';
import { Callback } from './components/signin/callback';
import { SignIn } from './components/signin/signIn';
import * as serviceWorker from './initilize/serviceWorker';
import { store } from './store';

console.log(`start ${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <Switch>
                    <Route path="/signin" component={SignIn} />
                    <Route path="/callback" component={Callback} />
                    <Auth>
                        <Route path="/" component={App} />
                    </Auth>
                </Switch>
                <GoogleAnalytics />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
